import React from "react";
import { motion } from "framer-motion";
import Reveal from "./Reveal";
import { DIFFERENTIATORS } from "../data/content";

export default function Difference() {
  return (
    <section id="difference" className="relative z-10 py-28 md:py-40 max-w-[1400px] mx-auto px-6 lg:px-12" data-testid="difference">
      <Reveal>
        <p className="text-sm font-500 tracking-[0.3em] uppercase text-[#D95A41] mb-6">Why KLC</p>
        <h2 className="text-4xl md:text-6xl font-900 tracking-tightest max-w-3xl leading-[1] text-[#F2EFE9]">
          We don&apos;t give legal answers. We give business solutions.
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10 rounded-3xl overflow-hidden">
        {DIFFERENTIATORS.map((d, i) => (
          <motion.div
            key={d.n}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: (i % 3) * 0.06 }}
            className="bg-[#050A14] p-8 min-h-[200px] flex flex-col justify-between"
            data-testid={`difference-${d.n}`}
          >
            <span className="text-4xl font-900 text-[#D95A41] tracking-tightest">{d.n}</span>
            <div>
              <h3 className="text-lg font-700 text-[#F2EFE9] mb-2 tracking-tight">{d.title}</h3>
              <p className="text-sm text-[#94A3B8] leading-relaxed">{d.body}</p>
            </div>
          </motion.div>
        ))}
        <div className="bg-[#D95A41] p-8 min-h-[200px] flex items-center">
          <p className="text-xl font-700 text-[#F2EFE9] leading-snug tracking-tight">
            One relationship. Every practice area. GC-level judgment.
          </p>
        </div>
      </div>
    </section>
  );
}
